<template>
  <div class="shim-room-card flex justify-between items-center mb-4 w-full">
    <div class="animate-custom-pulse left-effect shim-content">
    </div>
    <div class="animate-custom-pulse right-effect shim-content">
    </div>
  </div>
</template>

<script>

export default {
  name: 'RecordingCardShimmer',
};
</script>
  
<style scoped>
* {
  font-family: 'JetBrains Mono', monospace !important;
}

.shim-room-card {
  height: 58px;
  padding: 10px 15px 10px 15px;
  border-top: 1px solid white;
  border-left: 1px solid white;
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  box-shadow: 3px 3px 0px 0px white;
}

.left-effect {
  flex: 0.4;
  height: 22px;
  width: 100px;
}

.right-effect {
  flex: 0.30;
  height: 22px;
  width: 100%;
}

.shim-content {
  background-color: #FFFFFF;
}

@keyframes shimmer-sweep {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

.animate-custom-pulse {
  background: linear-gradient(90deg, #23242b 25%, #3d3e49 50%, #23242b 75%);
  background-size: 200% 100%;
  animation: shimmer-sweep 1.3s linear infinite;
}

@media (max-width: 499px) {}
</style>
  